export default "__VITE_ASSET__BcwkohCy__"